import React from 'react'
import selectn from 'selectn'
import { AnchorLink } from '../../../common'

const ScorecardSummary = ({
  fullSummaryLink = '',
  innings = {},
  isLimitedOvers
}) => {
  return (
    <div className="cricinfo__content__item">
      <h2 className="cricinfo__sub-title">Scorecard Summary</h2>
      <table className="cricinfo__table">
        {
          Object.keys(innings).map((innCount) => {
            const { team, batsmen, bowlers } = innings[innCount]
            const teamHead = (
              <thead>
                <tr className="cricinfo__table__tr">
                  <th className="cricinfo__table__th cricinfo__type__align--left">
                    {team.teamDisplayName} { isLimitedOvers ? '' : team.innDisplayName }
                  </th>
                  <th className="cricinfo__table__th cricinfo__type__align--right">
                    {team.inningsRunWicket}
                  </th>
                </tr>
              </thead>
            )
            const teamBody = (
              <tbody>
                { batsmen &&
                  batsmen.map((b, j) => {
                    const stats = b.stats || {}
                    // Need to show * for not out player
                    const isNotOut = selectn('notouts.value', stats) == '1' ? true : false
                    const runsScored = selectn('runs.value', stats)
                    const ballsFaced = selectn('ballsFaced.value', stats)
                    const name = `${b.name || '-'}${isNotOut ? '*' : ''}`
                    const runsAndBalls = (runsScored && ballsFaced) ? `${runsScored} (${ballsFaced})` : '-'

                    return (
                      <tr  key={j} className="cricinfo__table__tr">
                        <td className="cricinfo__table__td cricinfo__type__align--left">
                          {name}
                        </td>
                        <td className="cricinfo__table__td cricinfo__type__align--right">
                          {runsAndBalls}
                        </td>
                      </tr>
                    )
                  })
                }
                { bowlers &&
                  bowlers.map((b, j) => {
                    const stats = b.stats || {}
                    const wicketsTaken = selectn('wickets.value', stats)
                    const runsConceded = selectn('conceded.value', stats)
                    const wicketAndRuns = (wicketsTaken && runsConceded) ? `${wicketsTaken}/${runsConceded}` : '-'

                    return (
                      <tr  key={j} className="cricinfo__table__tr">
                        <td className="cricinfo__table__td cricinfo__type__align--left">
                          {b.name || '-'}
                        </td>
                        <td className="cricinfo__table__td cricinfo__type__align--right">
                          {wicketAndRuns}
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            )
            return [ teamHead, teamBody ]
          })
        }
        <tfoot>
          <tr className="cricinfo__table__tr">
            <td colSpan="2" className="cricinfo__table__td cricinfo__table__td--footer cricinfo__type__align--center">
              {
                fullSummaryLink &&
                <AnchorLink 
                  classes="cricinfo__type__link" 
                  to={fullSummaryLink} text="Full Scorecard" />
              }
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

export default ScorecardSummary



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/lite/ScorecardSummary.jsx